import { createSlice } from "@reduxjs/toolkit";
import { toGetStatistics } from "../actions/statistics.actions";
import { toGetPrivacy } from "../actions/privacy.actions";

const initialState = {
  privacy: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const privacySlice = createSlice({
  name: "privacy",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetPrivacy.pending, (state) => {
      state.privacy = { list: [], status: "idle" };
    });
    builder.addCase(toGetPrivacy.fulfilled, (state, action) => {
      state.privacy = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetPrivacy.rejected, (state, action) => {
      state.privacy = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default privacySlice.reducer;
